import React, { useState, useCallback } from 'react';
import { useLocationSearch } from '../hooks/useLocationSearch';
import { useLocationCoordinates } from '../hooks/useLocationCoordinates';
import { useLocationPagination } from '../hooks/useLocationPagination';
import { PaginationProvider } from '../contexts/PaginationContext';
import LocationLayout from '../components/layout/LocationLayout';
import NoResults from '../components/noResults/NoResults';

const Widget = () => {
	// Custom hooks for separation of concerns
	const { paginationData, currentPage, handlePageChange } =
		useLocationPagination();

	// Track current page locations for map pins
	const [currentPageLocations, setCurrentPageLocations] = useState([]);

	// Compose page-change: update both pagination state AND map-pin state
	const composedPageChange = useCallback(
		(data) => {
			handlePageChange(data);
			setCurrentPageLocations(data.paginatedData || []);
		},
		[handlePageChange]
	);

	const {
		isLoading,
		errorMsg,
		noResults,
		tileData,
		locationCount,
		allLocationData,
		showMap,
		range,
		setRange,
		resetTriggers
	} = useLocationSearch(paginationData);

	// Get coordinates from location selection (ws-locations-control)
	const coordinates = useLocationCoordinates();

	// Loading state
	if (isLoading) return <div>Loading...</div>;

	// Error state
	if (errorMsg) return <div>Error: something went wrong</div>;

	// No results state
	if (noResults)
		return (
			<NoResults
				isNoResults
				currentRange={range}
				onRangeChange={setRange}
			/>
		);

	// Main layout
	return (
		<PaginationProvider
			value={{
				totalCount: locationCount,
				allData: allLocationData,
				onPageChange: composedPageChange,
				resetTriggers,
				currentPage
			}}
		>
			<div className="location-search-container">
				<LocationLayout
					tileData={tileData}
					showMap={showMap}
					coordinates={coordinates}
					currentPageLocations={currentPageLocations}
				/>
			</div>
		</PaginationProvider>
	);
};

export default Widget;
